import type { IngestMessage, IngestRequest, IngestStep } from "@/workers/audioIngest.ts";

export type { IngestStep };

export type IngestProgress = (step: IngestStep) => void;

/**
 * Hands samples to the ingest worker and resolves when both cache files exist. The
 * buffers are transferred, so a long recording is not copied a second time.
 */
export function ingestAudio(request: IngestRequest, onProgress?: IngestProgress): Promise<void> {
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL("@/workers/audioIngest.ts", import.meta.url), {
      type: "module",
    });

    worker.addEventListener("message", (event: MessageEvent<IngestMessage>) => {
      const message = event.data;
      if (message.kind === "progress") {
        onProgress?.(message.step);
        return;
      }
      worker.terminate();
      if (message.kind === "done") resolve();
      else reject(new Error(message.error));
    });

    worker.addEventListener("error", (event) => {
      worker.terminate();
      reject(new Error(event.message || "音声の処理に失敗しました"));
    });

    worker.postMessage(
      request,
      "samples" in request
        ? [request.samples.buffer]
        : request.channels.map((channel) => channel.buffer),
    );
  });
}
